import styled from "styled-components";
import AreaSourceTypeSelect from "components/common/panel/AreaSourceTypeSelect";
import PanelUpload from "../PanelUpload";
import AreaSourceFields from "../AreaSourceFields";
import { PlaySource } from "type/panel/Panel.type";

type Props = {
  onNewSourceAdd: Function;
};

const AreaSourceNew = ({ onNewSourceAdd }: Props) => {
  const sourceFieldsUpdateHandle = (sourceFields: PlaySource) => {
    onNewSourceAdd(sourceFields);
  };

  return (
    <AreaSourceFields
      defaultSourceFields={null}
      onSourceFieldsUpdate={sourceFieldsUpdateHandle}
      onCancel={() => null}
    />
  );
};

export default AreaSourceNew;
